/**************************************************
 * Nombre:       Dialogo_Despacho
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../../Recursos/logo_redondo.svg'
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import Formulario_Deposito_Validar from "../../Formularios/Depositos/Formulario_Deposito_Validar";
import {ESTADOSDEPOSITOS} from "../../../Constantes";
import {aceptarDeposito} from "../../../CodNegocio/Depositos/aceptarDeposito";
import {useContext} from "react";
import {usuarioContext} from "../../../App";
import {rechazarDeposito} from "../../../CodNegocio/Depositos/rechazarDeposito";
import {guardarDoc} from "../../../Servicios/BD/guardarDoc";

const Dialogo_Deposito_Validar = ({datos, cerrar, realizado}) => {
    const cData = useContext(usuarioContext)
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        switch (entidad.estado) {
            case ESTADOSDEPOSITOS[0].nombre: //Aceptado
                iniciarCarga('Aceptando deposito')
                await aceptarDeposito(entidad, cData.usuario.tipo)
                terminar({aviso: 'Deposito aceptado con exito'})
                break
            case ESTADOSDEPOSITOS[1].nombre: //Rechazado
                iniciarCarga('Rechazando deposito')
                await rechazarDeposito(entidad, cData.usuario.tipo)
                terminar({aviso: 'Deposito rechazado'})
                break
            default:
                iniciarCarga('Actualizando Informacion')
                await guardarDoc('depositos', entidad)
                terminar({aviso: 'Deposito aceptado con exito'})
                break
        }

    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Deposito_Validar props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Deposito_Validar